import "./WhyChooseGeegStack.css";

export default function WhyChooseGeegStack() {
  return (
    <div className="why-geegstack">
      <div className="why-geegstak-content">
        <div className="why-geegstack-img"></div>
        <div className="why-geegstack-text">
          <h1>Why choose Geegstack?</h1>
          <p>
            Geegatack Academy is the most beginner friendly, yet comprehensive
            tech school in Ibadan – we take students from ground
            zero to become job ready in the shortest possible time.
          </p>

          <p className="reason-head">
            Here are some reasons why Geegstack is the best tech
            school for you:
          </p>
          <ul className="reasons">
            <li>
              The program is simplified for every student. It takes anyone
              irrespective of their background up to becoming a confident
              programmer.
            </li>

            <li>
              We provide you with all the tools you need to have a hassle free
              learning
            </li>
            <li>
              We don’t leave you alone after graduation, we provide our
              graduates with support and guidance to thrive in their career.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
